import { Chart, CategoryScale } from 'chart.js';

export const drawRightBorderPlugin = {
  id: 'drawRightBorder',
  afterDraw(chart: Chart) {
    const {
      ctx,
      chartArea: { top, bottom, right },
      scales: { x },
    } = chart;

    const xScale = x as CategoryScale;
    const grid = xScale.options.grid;

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(right - 1, top);
    ctx.lineTo(right - 1, bottom);

    // Set line width
    ctx.lineWidth = 1;

    // Set stroke style
    const color = Array.isArray(grid.color)
      ? (grid.color[0]?.toString() ?? '#ccc')
      : (grid.color?.toString() ?? '#ccc');
    ctx.strokeStyle = color;

    ctx.stroke();
    ctx.restore();
  },
};
